module.exports = __webpack_public_path__ + "static/image-jag-fff489c82d6c6ec04a62e051580a9190.jpg";